<template>
	<app-panel title="Journey Notes" class="mt-3" @click="journeyNotesOpen = true">
		<div class="flex items-center">
			<div class="flex-2 flex">
				<div class="flex flex-col space-y-2">
					<div class="flex items-center">
						<p class="text-gray-700 text-sm">
							{{
								journey!.notes
									? truncateText(journey!.notes, 50)
									: 'No notes for this Journey'
							}}
						</p>
					</div>
				</div>
			</div>

			<div v-if="attachments.length > 0" class="flex-1 ml-auto flex justify-end text-right">
				<app-icon :icon="['fas', 'fa-paperclip']" class="text-2xl text-mabey-950" />
			</div>
		</div>
	</app-panel>

	<slideover title="Journey Notes" :open="journeyNotesOpen" @close="journeyNotesOpen = false">
		<p class="text-sm">{{ journey!.notes }}</p>

		<div v-if="attachments.length > 0">
			<h3 class="font-bold mt-4">Attachments</h3>

			<div class="space-x-2 mt-4 flex items-end">
				<div v-for="(attachment, index) in attachments" :key="index">
					<app-button
						icon="fa-paperclip"
						type="textarea"
						:to="attachment.link"
						target="_blank">
						{{ attachment.name }}</app-button
					>
				</div>
			</div>
		</div>
	</slideover>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import type { Journey } from '@/data/schema/journey'
	import type { Attachment } from '@/data/types/attachment'

	withDefaults(
		defineProps<{
			journey: Journey
		}>(),
		{
			journey: undefined
		}
	)

	const journeyNotesOpen = ref(false)
	const attachments = ref<Attachment[]>([])

	function truncateText(text: string, maxLength: number) {
		if (text.length > maxLength) {
			return text.substring(0, maxLength) + '...'
		} else {
			return text
		}
	}
</script>
